"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ErrorTable = _interopRequireDefault(require("./ErrorTable"));

var _Table = _interopRequireDefault(require("./Table"));

var DataTable = function DataTable(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      error = _ref.error,
      footer = _ref.footer,
      loading = _ref.loading,
      loadingRows = _ref.loadingRows,
      retry = _ref.retry,
      tableName = _ref.tableName;
  var hiddenColumns = [];
  columns.forEach(function (column) {
    if (column.hidden === true) {
      hiddenColumns.push(column.accessor);
    }
  });

  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_Table.default, {
      columns: columns,
      footer: footer,
      data: data,
      loading: true,
      loadingRows: loadingRows,
      tableName: tableName,
      hiddenColumns: hiddenColumns
    });
  }

  if (error) {
    return /*#__PURE__*/_react.default.createElement(_ErrorTable.default, {
      retry: retry,
      columns: columns,
      hiddenColumns: hiddenColumns,
      tableName: tableName,
      footer: footer
    });
  }

  return /*#__PURE__*/_react.default.createElement(_Table.default, {
    columns: columns,
    data: data,
    loading: loading,
    tableName: tableName,
    hiddenColumns: hiddenColumns,
    footer: footer
  });
};

DataTable.defaultProps = {
  error: false,
  loading: false,
  loadingRows: 3
};
var _default = DataTable;
exports.default = _default;